export const Wordmark = ({ light = false, className = "" }) => (
  <img
    src="/logo.png"
    alt="VideoActive. Your Message, Seen"
    className={`w-auto select-none ${className}`}
    draggable={false}
    // The logo is white with transparency. On light backgrounds we invert it
    // so the mark becomes dark and stays readable.
    style={light ? undefined : { filter: "invert(1)" }}
  />
);
